import { createSelector } from 'reselect';
import { SET_LAYOUT_MODE } from '../../../constants/layoutMode';
import type rootReducer from '../../../reducers';

export type RootState = ReturnType<typeof rootReducer>;

export interface LayoutModeState {
  isDesktop: boolean;
}

export const initialState: LayoutModeState = {
  isDesktop: false,
};

export const reducer = (
  state = initialState,
  action: { type: string; payload: boolean }
): LayoutModeState => {
  switch (action.type) {
    case SET_LAYOUT_MODE:
      return { ...state, isDesktop: action.payload };

    default:
      return state;
  }
};

export default reducer;

export const layoutModeSelector = (state: RootState) => {
  return state?.ui?.layoutMode || initialState;
};
export const isDesktopLayoutSelector = createSelector(
  layoutModeSelector,
  (state) => state?.isDesktop ?? initialState.isDesktop
);
